import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, from, Observable, Subject, switchMap, throwError } from 'rxjs';
import { BaseUrl } from 'src/app/framework/constants/url-constants';

@Injectable({
  providedIn: 'root'
})
export class MyReportsService {

  private analysisRequestedSource = new Subject<boolean>();
  analysisRequested = this.analysisRequestedSource.asObservable();
  constructor(private readonly http: HttpClient) { }


  getPatientAnalysisRequestStatus(patientId): Observable<any> {
    const href = `${BaseUrl.PATIENT}/report/${patientId}/has-analysis-requested`;
    return this.http.get<any>(href);
  }

  getPatientbyId() {
    const href = `${BaseUrl.PATIENT}/patients/get-patient`;
    return this.http.get<any>(href);

  }

  findAllPatientReports(page: number, filter: any): Observable<any> {
    const href = `${BaseUrl.PATIENT}/report/requested`;
    let params = new HttpParams()
      .set('patientId', filter.patientId.toString())
      .set('page', page.toString())

    return this.http.get<any>(href, { params });
  }

  getTemplateDetails(templateId) {
    const href = `${BaseUrl.TEMPLATE}/template/${templateId}`;
    return this.http.get<any>(href);
  }

   notifyAnalysisRequested(value: boolean) {
    this.analysisRequestedSource.next(value);
  }

  findAllPatientReport(page: number, body: any): Observable<any> {
    const href = `${BaseUrl.PATIENT}/report/patient`;
    return this.http.post<any>(href, body, {
      params: new HttpParams()
        .set('page', page.toString())
    });
  }

  downloadReportFile(filePath, templateName): Observable<any>{    
    const href =`${BaseUrl.PATIENT}/report/template-report/download`;
    const requestBody = { filePath, templateName};
    return this.http.post(href, requestBody, { responseType: 'blob', observe: 'response' }).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 422 && error.error instanceof Blob) {
          return from(error.error.text()).pipe(
            switchMap((errorText: string) => {
              try {
                const errorData = JSON.parse(errorText);
                
                const applicationMessage = errorData?.applicationMessage || 'An error occurred';
               
                return throwError(() => applicationMessage);
              } catch (e) {
                return throwError(() => new Error('Error parsing error response'));
              }
            })
          );
        }
      })
    );
  }

  viewReport(patientId , templateId){
    const href = `${BaseUrl.PATIENT}/report/view/${patientId}/${templateId}`;
    return this.http.get<any>(href);
  }

  download(filePath) {
    const href =`${BaseUrl.TEMPLATE}/template/document`;
    return this.http.post(href, filePath,{responseType: 'blob',observe: 'response'});
  }
  
}
